import React from 'react';

import { Typography, SvgIcon } from '@mui/material';

import { ReactComponent as HelpIcon } from 'mui/assets/icons/help.svg';
import { ReactComponent as ShopIcon } from 'mui/assets/icons/shopping-basket.svg';
import { ReactComponent as ChatIcon } from 'mui/assets/icons/chat-bubble.svg';

import Link from '../../../../elements/Link';

import { StyledIconLinks } from './LinksButtonsDrawerStyles';

const IconLinks = ({ shopLink, faqLink, chatLink }) => {
  return (
    <StyledIconLinks>
      {chatLink?.url ? (
        <Typography component={Link} variant="DS_copyMediumBold" url={chatLink.url} ariaLabel={chatLink.title}>
          <SvgIcon component={ChatIcon} inheritViewBox={true} />
          <span>{chatLink.title}</span>
        </Typography>
      ) : null}
      {faqLink?.url ? (
        <Typography component={Link} variant="DS_copyMediumBold" url={faqLink.url} ariaLabel={faqLink.title}>
          <SvgIcon component={HelpIcon} inheritViewBox={true} />
          <span>{faqLink.title}</span>
        </Typography>
      ) : null}
      {shopLink?.url ? (
        <Typography component={Link} variant="DS_copyMediumBold" url={shopLink.url} ariaLabel={shopLink.title}>
          <SvgIcon component={ShopIcon} inheritViewBox={true} />
          <span>{shopLink.title}</span>
        </Typography>
      ) : null}
    </StyledIconLinks>
  );
};

export default IconLinks;
